import { createActionCreator, createReducer } from 'deox';
import { AppState } from 'types/AppState';
import { Audio, Song } from 'types/Audio';
import { NewSong, mapToOldFormatSong, combineSongsCategories } from 'utils/audio/audio';

const defaultState: Audio = null;

export const setAudio = createActionCreator('AUDIO/SET_AUDIO', resolve => (audio: Audio | null) =>
  resolve(audio)
);

export const setAudioRange = createActionCreator(
  'AUDIO/SET_RANGE',
  resolve => (trimStart: number, trimDuration: number) => resolve({ trimStart, trimDuration })
);

export const audio = createReducer(defaultState, handle => [
  handle(setAudio, (_, { payload }) => payload),
  handle(setAudioRange, (state, { payload: { trimStart, trimDuration } }) => ({
    ...state,
    trimDuration,
    trimStart
  }))
]);

export const getAudio = (state: AppState): Audio => state.audio;
export const isAudioPaid = (state: AppState): boolean => state.audio?.isPaid;

export const getAudiosMapped = (songs: NewSong[]): Song[] => songs.map(mapToOldFormatSong);
export const getAudiosCombined = (songs: Song[]) => songs.map(combineSongsCategories);
